import React, { useCallback, useState } from 'react';

const PopoutListAction = ({ id, isExpanded, onExpand, onCollapse, renderAction }) => {
    const handleExpand = useCallback(() => {
        onExpand(id);
    }, [id]);

    return (
        <div className={'item' + (isExpanded ? ' expanded' : '')}>
            { renderAction(id, handleExpand, onCollapse) }
        </div>
    );
}

const PopoutListActions = ({ actions, renderAction, updatePopoutPosition, size = 'default' }) => {
    const [expanded, setExpanded] = useState(null);

    const handleExpand = useCallback(id => {
        setExpanded(id);

        setTimeout(() => {
            updatePopoutPosition && updatePopoutPosition();
        }, 100);
    }, [updatePopoutPosition]);

    const handleCollapse = useCallback(() => {
        setExpanded(null);

        setTimeout(() => {
            updatePopoutPosition && updatePopoutPosition();
        }, 100);
    }, [updatePopoutPosition]);

    return (
        <div className={'popout-list popout-list-actions popout-list-' + size + ' ' + (expanded ? ' has-expanded-item' : '')}>
            {
                actions.map(actionId => (
                    <PopoutListAction
                        key={actionId}
                        id={actionId}
                        isExpanded={expanded === actionId}
                        renderAction={renderAction}
                        onExpand={handleExpand}
                        onCollapse={handleCollapse}
                    />
                ))
            }
        </div>
    );
}

export default PopoutListActions;
